$(document).ready(function(){

	var $mainNavLayer = $('.nav-layer-mobile.mainnav');
	var $userMenuLayer = $('.nav-layer-mobile.usermenu');
	var $listViewSortLayer = $('.nav-layer-mobile.campaignlistsort');
	var $listViewFilterLayer = $('.nav-layer-mobile.campaignlistfilter');

	$('.open-menu, .js-close-main-nav').on('click', function(e) {
		e.preventDefault();
		$mainNavLayer.toggleClass( 'active' );
		$userMenuLayer.removeClass( 'active' );
		$listViewSortLayer.removeClass( 'active' );
		$listViewFilterLayer.removeClass( 'active' );
	});

	$('.usr.on, .js-close-usr-menu').on('click', function(e) {
		e.preventDefault();
		$userMenuLayer.toggleClass( 'active' );
		$mainNavLayer.removeClass( 'active' );
		$listViewSortLayer.removeClass( 'active' );
		$listViewFilterLayer.removeClass( 'active' );
	});

	$('.js-show-listview-sort, .js-close-campaignlistsort').on('click', function(e) {
		e.preventDefault();
		$listViewSortLayer.toggleClass( 'active' );
		$mainNavLayer.removeClass( 'active' );
		$userMenuLayer.removeClass( 'active' );
		$listViewFilterLayer.removeClass( 'active' );
	});

	$('.js-show-listview-filter, .js-close-campaignlistfilter').on('click', function(e) {
		e.preventDefault();
		$listViewFilterLayer.toggleClass( 'active' );
		$mainNavLayer.removeClass( 'active' );
		$userMenuLayer.removeClass( 'active' );
		$listViewSortLayer.removeClass( 'active' );
	});

	$listViewSortLayer.find( 'a' ).on( 'click', function(e){
		e.preventDefault();
		$listViewSortLayer.removeClass( 'active' );
	});

	$( document ).mouseup( e => {
		if ( $mainNavLayer.hasClass( 'active' ) ) {
			if ( !$mainNavLayer.is( e.target ) && $mainNavLayer.has( e.target ).length === 0 ) {
				$mainNavLayer.removeClass( 'active' );
			}
		}

		if ( $userMenuLayer.hasClass( 'active' ) ) {
			if ( !$userMenuLayer.is( e.target ) && $userMenuLayer.has( e.target ).length === 0 ) {
				$userMenuLayer.removeClass( 'active' );
			}
		}

		if ( $listViewSortLayer.hasClass( 'active' ) ) {
			if ( !$listViewSortLayer.is( e.target ) && $listViewSortLayer.has( e.target ).length === 0 ) {
				$listViewSortLayer.removeClass( 'active' );
			}
		}

		if ( $listViewFilterLayer.hasClass( 'active' ) ) {
			if ( !$listViewFilterLayer.is( e.target ) && $listViewFilterLayer.has( e.target ).length === 0 ) {
				$listViewFilterLayer.removeClass( 'active' );
			}
		}
	});
});
